import { Flex, FlexProps } from '@mantine/core';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const StyledFlexColumn = styled(Flex)<FlexProps>`
	flex-direction: column;
	gap: 0.25rem;
`;

export const StyledFlexRow = styled(Flex)<FlexProps>`
	gap: 0.25rem;
`;

export const StyledDealCard = styled(Link)`
	display: block;
	cursor: pointer;
	padding: 1rem;
	background-color: ${({ theme }) => theme.v2.color.neutral[100]};
	margin-bottom: 0.5rem;
	margin-right: 0.5rem;
	margin-left: 0.5rem;
	margin-top: 0.5rem;
	border-radius: 0.5rem;
	color: inherit;
	text-decoration: none;

	&:hover {
		color: inherit;
		text-decoration: none;
	}
`;
